<template>
    <div>
        <div class="column-layout clearfix">
            <div v-cloak class="left-column fl" :class="{'active' : !treeCollapse}">
                <div class="tab-container base">
                    <div class="tabs-nav">
                        <ul class="head">
                            <li class="head-item current">组织机构</li>
                        </ul>
                    </div>
                </div>
                <div id="tree-menu">
                    <swb-org-tree :enableSearch="true" :bizDepart="true" @notity-change="notityChange($event)" @show-tree-collapse="showTreeCollapse($event)"></swb-org-tree>
                </div>
            </div>
            <div class="right-column fl">
                <div style="margin: 5px 0;" class="content-caption dashed">
                    <span class="color-laber">{{comInfo.name}}</span>
                </div>
                <div class="switch-list clearfix ml15">
                    <el-radio-group v-model="comRole">
                        <div v-for="comRole in comRoleList" class="switch-item ellipsis-1" style="width: auto;margin-right: 30px">
                            <el-radio :label="comRole">
                                <span>{{comRole.name}}</span>
                                <el-tag type="success" v-if="comRole.mobAppRoleCode != null" close-transition>{{comRole.mobAppRoleName}}</el-tag>
                            </el-radio>
                        </div>
                    </el-radio-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { checkUserActionPerm } from '../index'
    //
    import servicerApi from '../../api/servicer'
    import servicerAuthxApi from '../../api/servicerAuthx'
    import userApi from '../../api/user'
    //
    import SwbOrgTree from '../orgStruct/OrgTree';
    Vue.regist(SwbOrgTree);
    //
    export default {
        name: 'swb-servicer-role-select',
        desc: '人员岗位配置',
        data: function () {
            return {
                thisComId: null,
                comInfo: {},
                comRoleList: [],
                userContext: {
                    scopeEntity: {}
                },
                treeCollapse: true,
                staff: null,
                multipleSelection: [],
                chekcedRoles: [],
                comRole: null,
                departGroups: [],
                roleIdsMap: {},
                stateMap: {}
            }
        },
        created: function () {
            //
            this.getUserInfoByContext();
        },
        methods: {
            checkActionPerm: function (action) {
                return checkUserActionPerm(SwbRetailerUserList.path, action, null);
            },
            initLoad(){
                let self = this;
                this.notityChange({
                    id: self.thisComId
                });
            },
            notityChange(eventData) {
                let self = this;
                this.initData();
                this.thisComId = eventData.id;
                this.getComDetail();
                this.getComRoleList();
            },
            initData(){
                this.checkedRoleIds = [];
            },
            getUserInfoByContext() {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == "info") {
                        self.userContext = result.data;
                        self.thisComId = result.data.scopeEntity.comId;
                        self.getComDetail();
                        self.notityChange({
                            id: self.userContext.scopeEntity.comId
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getComDetail() {
                let self = this;
                let postData = {
                    comId: this.thisComId
                };
                let theLoading = MsgBox.loading();
                servicerApi.getServicerCom(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        self.comInfo = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getComRoleList () {
                let self = this;
                let postData = {};
                postData.comId = this.thisComId;
                postData.includeOther = true;
                postData.disabled = false;
                //
                let theLoading = MsgBox.loading();
                servicerAuthxApi.getServicerComRoleList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        self.comRoleList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            showTreeCollapse: function (treeCollapse) {
//                console.log(treeCollapse);
                this.treeCollapse = treeCollapse;
            },
            handleSelectionChange: function (val) {
                this.multipleSelection = val;
                console.log('现在选中的list：', this.multipleSelection);
            },
            toggleSelection(rows) {
                if(rows) {
                    rows.forEach(row => {
                        this.$refs.roleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.roleTable.clearSelection();
                }
            },
            selectable: function (row, index) {
                if(row.departId == -1) {
                    return false;
                }
                return true;
            },

            getDlgResult(){
                let result = {};
                let resultData = {};
                if(Utils.isNoB(this.comRole)) {
                    result.type = 'warn';
                    result.message = "请选择岗位信息";
                    return result;
                }
                let comInfo = this.comInfo;
                let comRole = this.comRole;
                resultData.comId = comInfo.id;
                resultData.comName = comInfo.name;
                resultData.comLevel = comInfo.level;
                resultData.roleId = comRole.id;
                resultData.roleName = comRole.name;
                result.type = 'info';
                result.data = resultData;
                return result;
            },
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/staffBiz/ServicerRoleForSelect.vue